/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 * - tnb-grid4-hotfix: 2026-07-13
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector('theme-drawer#cart-drawer');

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

const tnbRouteFixes = new Map([
  ['/pages/allgemeine-verkaufsbedingungen', '/policies/terms-of-service'],
  ['/pages/cookie-richtlinie', '/pages/datenschutzrichtlinie-naomi-ashanti'],
  ['/pages/ruckgabe-und-umtausch', '/policies/refund-policy'],
  ['/pages/impressum', '/pages/impressum-naomi-ashanti'],
  ['/pages/datenschutzerklarung', '/pages/datenschutzrichtlinie-naomi-ashanti'],
  ['/pages/versandrichtlinie', '/policies/shipping-policy'],
  ['/pages/contact', '/pages/kontakt'],
  ['/pages/bestellverfolgung', '/pages/kontakt'],
  ['/pages/haufige-fragen', '/pages/kontakt'],
  ['/collections/geschenkfertige-strausse', '/collections/geschenkfertige-strausse-blumen'],
  ['/collections/angebote', '/collections/angebote-blumen'],
  [
    '/products/angebote-012-crochet-flower-bouquet-handmade-yarn-lily-wild-bloom-arrangement-personalized-gi',
    '/products/angebote-012-handgemachter-lilien-wildblumen-strauss',
  ],
  [
    '/products/geschenkfertige-strausse-005-crochet-flower-bouquet-handmade-yarn-lily-wild-bloom-arrangement-personalized-gi',
    '/products/geschenkfertige-strausse-005-handgemachter-lilien-wildblumen-strauss',
  ],
]);

function normalizePath(value) {
  try {
    return new URL(value, window.location.origin).pathname;
  } catch {
    return '';
  }
}

function applyTnbRouteFixes() {
  const currentPath = window.location.pathname.replace(/\/$/, '');
  const redirectPath = tnbRouteFixes.get(currentPath);

  if (redirectPath) {
    window.location.replace(`${redirectPath}${window.location.search}${window.location.hash}`);
    return;
  }

  document.querySelectorAll('a[href]').forEach((link) => {
    const oldPath = normalizePath(link.getAttribute('href'));
    const newPath = tnbRouteFixes.get(oldPath);

    if (!newPath) return;

    link.setAttribute('href', newPath);

    if (oldPath.includes('crochet-flower-bouquet-handmade-yarn-lily-wild-bloom')) {
      const cleanTitle = 'Handgemachter Lilien- und Wildblumenstrauss';
      link.setAttribute('aria-label', cleanTitle);
      link.querySelectorAll('.tnb-product-card__title').forEach((title) => {
        title.textContent = cleanTitle;
      });
      link.querySelectorAll('img[alt]').forEach((image) => {
        image.setAttribute('alt', cleanTitle);
      });
    }
  });
}

function initTnbRouteFixes() {
  applyTnbRouteFixes();

  const observer = new MutationObserver(() => applyTnbRouteFixes());
  observer.observe(document.documentElement, { childList: true, subtree: true });
}

const naomiComplianceLinkFixes = new Map([
  ['/pages/ruckgabe-und-umtausch', '/policies/refund-policy'],
  ['/pages/allgemeine-verkaufsbedingungen', '/policies/terms-of-service'],
  ['/pages/allgemeine-nutzungsbedingungen', '/policies/terms-of-service'],
  ['/pages/cookie-richtlinie', '/pages/datenschutzrichtlinie-naomi-ashanti'],
  ['/pages/impressum', '/pages/impressum-naomi-ashanti'],
]);

function applyNaomiComplianceFixes() {
  document.querySelectorAll('a[href]').forEach((link) => {
    const href = link.getAttribute('href') || '';
    const path = normalizePath(href);
    const fixedPath = naomiComplianceLinkFixes.get(path);

    if (fixedPath) {
      link.setAttribute('href', fixedPath);
    }

    if (href.includes('penvesna555@gmail.com')) {
      link.setAttribute('href', 'mailto:service@naomiashanti.shop');
      link.textContent = 'service@naomiashanti.shop';
    }
  });

  const footerBrand = document.querySelector('.tnb-footer__brand');

  if (footerBrand) {
    footerBrand.innerHTML = [
      '<h2>Informationen zur Marke</h2>',
      '<p>E-Mail: <a href="mailto:service@naomiashanti.shop">service@naomiashanti.shop</a></p>',
      '<p>NAOMI ASHANTI LLC</p>',
      '<p>114 S MILLER ST, MESA, AZ 85204, United States</p>',
      '<p>Servicezeiten: Montag bis Freitag.</p>',
    ].join('');
  }

  document.querySelectorAll('body *').forEach((node) => {
    if (node.childNodes.length !== 1 || node.firstChild.nodeType !== Node.TEXT_NODE) return;
    const text = node.textContent || '';
    const fixed = text
      .replaceAll('penvesna555@gmail.com', 'service@naomiashanti.shop')
      .replaceAll('service@oraniatelierberliny.shop', 'service@naomiashanti.shop')
      .replaceAll('oraniatelierberliny.shop', 'naomiashanti.shop')
      .replaceAll('Orani Atelier Berlin', 'Naomi Ashanti');

    if (fixed !== text) {
      node.textContent = fixed;
    }
  });
}

function initNaomiComplianceFixes() {
  applyNaomiComplianceFixes();

  const observer = new MutationObserver(() => applyNaomiComplianceFixes());
  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
}

const naomiCookieBannerSelectors = [
  '#shopify-pc__banner',
  '#shopify-pc__prefs',
  '.shopify-pc__banner',
  '.shopify-pc__prefs',
  '[id^="shopify-pc__"]',
  '[class^="shopify-pc__"]',
  '[class*=" shopify-pc__"]',
  'shopify-privacy-banner',
  'privacy-banner',
  'script[src*="/privacy-banner/"]',
  'script[src*="storefront-banner.js"]',
];

function removeNaomiCookieBanner() {
  document.querySelectorAll(naomiCookieBannerSelectors.join(',')).forEach((node) => node.remove());
  document.documentElement.classList.remove('shopify-pc__banner-open', 'shopify-pc__prefs-open');

  if (document.body) {
    document.body.classList.remove('shopify-pc__banner-open', 'shopify-pc__prefs-open');
    document.body.style.removeProperty('overflow');
  }
}

function initNaomiCookieBannerRemoval() {
  removeNaomiCookieBanner();

  const observer = new MutationObserver(removeNaomiCookieBanner);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.setTimeout(removeNaomiCookieBanner, 400);
  window.setTimeout(removeNaomiCookieBanner, 1200);
  window.setTimeout(removeNaomiCookieBanner, 3000);
  window.setTimeout(removeNaomiCookieBanner, 6000);
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTnbRouteFixes, { once: true });
  document.addEventListener('DOMContentLoaded', initNaomiComplianceFixes, { once: true });
  document.addEventListener('DOMContentLoaded', initNaomiCookieBannerRemoval, { once: true });
} else {
  initTnbRouteFixes();
  initNaomiComplianceFixes();
  initNaomiCookieBannerRemoval();
}
